export const RS485_BAUD_OPTIONS = ['110', '300', '600', '4800', '9600', '14400', '19200', '57600', '115200']

export const RS485_DATA_BIT_OPTIONS = [
  { label: '8', value: '12' },
  { label: '7', value: '8' },
  { label: '6', value: '4' },
  { label: '5', value: '0' },
]

export const RS485_STOP_BIT_OPTIONS = [
  { label: '1', value: '16' },
  { label: '2', value: '48' },
]

export const RS485_PARITY_OPTIONS = [
  { label: 'None', value: '0' },
  { label: 'Odd', value: '3' },
  { label: 'Even', value: '2' },
]

export const RS485_MODE_OPTIONS = [
  { label: 'Meter', value: '0' },
  { label: 'Inverter', value: '1' },
]

export const RS485_FALLBACK_MODEL_OPTIONS = ['1']

export const DEFAULT_RS485_COM1_SETTINGS = {
  enabled: false,
  address: '',
  address2: '',
  mode: '',
  baudRate: '',
  dataBit: '',
  model: '',
  model2: '',
  stopBit: '',
  parity: '',
}

export function getOptionValue(option) {
  return typeof option === 'object' ? option.value : option
}

export function getOptionLabel(option) {
  return typeof option === 'object' ? option.label : option
}

export function ensureSelectedOption(options, value) {
  if (!value || options.some((option) => getOptionValue(option) === value)) {
    return options
  }

  return [value, ...options]
}

export function buildRs485Com1Config(previousCom1 = {}, formValues = {}) {
  const enabled = formValues.enabled ?? formValues.com1Enabled
  const address = formValues.address ?? formValues.com1Address ?? ''
  const address2 = formValues.address2 ?? formValues.com1Address2 ?? ''
  const mode = formValues.mode ?? formValues.com1Mode ?? '0'
  const model = formValues.model ?? formValues.com1Model ?? ''
  const model2 = formValues.model2 ?? formValues.com1Model2 ?? ''
  const baud = formValues.baudRate ?? formValues.com1Baud ?? ''
  const dataBit = formValues.dataBit ?? formValues.com1DataBit ?? ''
  const stopBit = formValues.stopBit ?? formValues.com1StopBit ?? ''
  const parity = formValues.parity ?? formValues.com1Parity ?? ''
  const isInverter = mode === '1'

  return {
    ...previousCom1,
    en: enabled ? '1' : '0',
    addr: address,
    addr2: isInverter ? '' : address2,
    mode: mode || '0',
    model,
    model2: isInverter ? '' : model2,
    baud,
    dbit: dataBit,
    sbit: stopBit,
    parity,
  }
}
